// extracted by mini-css-extract-plugin
export var dateStyle = "template_long_form_text_entry-module--dateStyle--Iuc5o";
export var longFormTextBodyStyle = "template_long_form_text_entry-module--longFormTextBodyStyle--tctZ-";
export var longFormTextWrapperStyle = "template_long_form_text_entry-module--longFormTextWrapperStyle--a-Icm";